<template>
  <div>
    <v-card class="main">
      <v-toolbar class="elevation-2" dense>
        <v-toolbar-title class="body-2 beez-bold">
          Role Maintenance
        </v-toolbar-title>
        <v-spacer />
      </v-toolbar>
      <v-card-text>
        <template v-for="(item, key) in honeyRoles">
          <role-configuration
            :key="key + 'config'"
            :title="changeCase(item.name)"
            :id="item.hexId"
          ></role-configuration>
        </template>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
import RoleConfiguration from '@/components/admin/RoleConfiguration'
import _ from 'lodash'

export default {
  name: 'RolesVsPrivilege',
  components: { RoleConfiguration },
  data() {
    return {
      loader: false
    }
  },
  computed: {
    ...mapState({
      honeyRoles: state => state.honeyRoles.honeyRoles
    }),
    ...mapGetters({
      can: 'can'
    })
  },
  mounted() {
    this.getHoneyRoles()
    this.getPrivileges()
  },
  methods: {
    changeCase(str) {
      return _.startCase(_.lowerCase(str))
    },
    async getHoneyRoles() {
      this.loader = true
      try {
        await this.$store.dispatch('fetchHoneyRoles')
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Roles',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.loader = false
    },
    async getPrivileges() {
      this.loader = true
      try {
        await this.$store.dispatch('fetchPrivileges')
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Privileges',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.loader = false
    }
  }
}
</script>

<style scoped></style>
